import { render, staticRenderFns } from "./SpecialWelcome.vue?vue&type=template&id=5c134fc9&"
import script from "./SpecialWelcome.vue?vue&type=script&lang=js&"
export * from "./SpecialWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports